module.exports = __webpack_public_path__ + "media/images/front/about/tsuchiya-1655f49d5456c9c1a0243857bcb314d3.jpg";